import { Badge } from "react-bootstrap";

import { useHistory } from "react-router-dom";
import TrellisLink from "components/core/basic/TrellisLink";
import { snakeCaseToSentenceCase } from "utils/formatText";
import * as Flags from "country-flag-icons/react/3x2";
import { TbBrandWalmart } from "react-icons/tb";
import { FaAmazon } from "react-icons/fa";
import { FaGoogle, FaShopify } from "react-icons/fa6";
import { css } from "../../../styled-system/css";
import type { OrgQueryV4Row } from "../perf_reports/api/organization/v4OrgReportByOrg";
import { useSetOrgId } from "../admin/api/useSetCurrentOrg";

const renderChannelIcon = (channel: string) => {
  switch (channel) {
    case "WALMART":
      return <TbBrandWalmart />;
    case "SHOPIFY":
      return <FaShopify />;
    case "GOOGLE":
      return <FaGoogle />;
    case "AMAZON":
    default:
      return <FaAmazon />;
  }
};
export const OrgCell = ({ orgData, marketPlace }: { orgData: OrgQueryV4Row; marketPlace: string }) => {
  const history = useHistory();
  const setOrgMutation = useSetOrgId();

  const {
    name,
    profile_type,
    amazon_profile__name,
    org_id,
    org_type: channel,
    org_is_visible: orgIsVisible,
    tags,
  } = orgData;

  let flagNationCode = marketPlace;

  if (flagNationCode === "USA") {
    flagNationCode = "US";
  }

  if (flagNationCode === "UK") {
    flagNationCode = "GB";
  }
  const Flag = Flags[flagNationCode as keyof typeof Flags];

  return (
    <TrellisLink
      id="categoryPage"
      to={"#"}
      onClick={() => {
        setOrgMutation.mutate(org_id, {
          onSuccess() {
            localStorage.setItem("Marketplace", marketPlace);
            localStorage.setItem("channel", channel.toLowerCase());
            history.push("/user/merchandising/dashboard");
            /*
            TODO: Below is bad, but fixing how we store channel and marketplace in state will open a can of worms
            The above dispatches and localStorage updates make everything functional with the right marketplace filters,
            but the seller marketplace and channel dropdowns will need an update to trigger a refetch without any type
            of hard reload once localStorage is updated
            */
            window.location.reload();
          },
        });
      }}
      style={{
        textDecoration: "none",
        fontWeight: "500",
        fontSize: "1.5rem",
        cursor: "pointer",
      }}
    >
      <div className={"fs-standard text-underline-hover"}>
        <strong className={"text-underline-hover"}>{name}</strong>
        <Flag style={{ width: "18px" }} className="ms-3" />
      </div>
      <i
        className="pe-3"
        style={{
          fontWeight: "light",
          color: "#666",
          fontSize: "1rem",
        }}
      >
        {amazon_profile__name}
      </i>

      <span style={{ marginLeft: "2px", marginRight: "2px" }}>{renderChannelIcon(channel)}</span>
      {!orgIsVisible && (
        <span
          style={{
            color: "#666",
            fontSize: "1rem",
            marginLeft: "1rem",
            fontWeight: "light",
            fontStyle: "italic",
          }}
        >
          Hidden
        </span>
      )}
      <br />
      <Badge
        className={`badge bg-trellis-${profile_type === "seller" ? "fuchsia" : "mauve"} fs-6 ${css({
          borderRadius: "5px",
          marginRight: "small",
        })}`}
        pill
      >
        {snakeCaseToSentenceCase(profile_type)}
      </Badge>
      {tags?.map((tag, index) => (
        <Badge
          className={`bg-trellis-mauve ${css({
            cursor: "pointer",
            marginRight: "small",
          })}`}
          pill
          key={`${tag}-${index}`}
        >
          {tag}
        </Badge>
      ))}
    </TrellisLink>
  );
};
